var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 57,
  viewBox: "0 0 56 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2249_45204)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 28C0 12.536 12.536 0 28 0C43.4639 0 56 12.536 56 28C56 43.4639 43.4639 56 28 56C12.536 56 0 43.4639 0 28Z",
  fill: "#FFCA05"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6839 30.8533L24.4082 41.5782L42.2491 23.7374C43.1603 22.8262 43.1603 21.3488 42.2491 20.4376C41.3377 19.5263 39.8605 19.5263 38.9491 20.4376L24.4082 34.9786L16.9838 27.5537C16.0726 26.6423 14.5952 26.6423 13.6839 27.5535C12.7727 28.4646 12.7727 29.9421 13.6839 30.8533Z",
  fill: "#001246"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2249_45204"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "white",
  transform: "translate(0 0.346191)"
})))));
export default SvgChecked;